import {
  ZoomingImage,
  CaseStudyDetailsStack,
  NavigationButton,
} from '@rumblefish/ui/Rumblefish23Theme';
import type { LatestCaseStudyProps } from './LatestCaseStudy.types';
import {
  CenterStack,
  StyledAccentBar,
  StyledContentStack,
  StyledDescription,
  StyledDescriptionStack,
  StyledHeader,
  StyledHeading,
  StyledImageSectionStack,
  StyledInfoStack,
  StyledStack,
  StyledTextStack,
  StyledTitle,
  LatestCaseStudySection,
  DesktopZoomingImage,
  MobileZoomingImage,
  GlowStack,
} from './styles';
export const LatestCaseStudy = ({
  latestCaseStudy,
  ...props
}: LatestCaseStudyProps): React.ReactElement => {
  const firstImgUrl =
    latestCaseStudy?.homePageFirstImg?.url ?? latestCaseStudy?.image?.url;
  const secondDesktopImgUrl = latestCaseStudy?.homePageSecondImgDesktop?.url;
  const secondMobileImgUrl = latestCaseStudy?.homePageSecondImgMobile?.url;

  return (
    <LatestCaseStudySection width="normal">
      <GlowStack />
      <StyledStack {...props}>
        <StyledHeader>
          <StyledHeading variant="h2">Latest case study</StyledHeading>
          <StyledAccentBar />
        </StyledHeader>

        <StyledTitle display={{ md: 'none' }} variant="display_sm">
          {latestCaseStudy?.title}
        </StyledTitle>

        <StyledContentStack>
          <StyledTextStack>
            <StyledTitle
              display={{ xs: 'none', md: 'block' }}
              variant="display_sm">
              {latestCaseStudy?.title}
            </StyledTitle>

            <StyledDescriptionStack>
              <StyledDescription variant="strong_500">
                {latestCaseStudy?.cardDescription}
              </StyledDescription>
              <NavigationButton
                target={`/case-studies/${latestCaseStudy?.slug || ''}`}
                buttonText="View this case study"
                color={'raspberry'}
                ariaLabel={latestCaseStudy?.title?.toString()}
              />
            </StyledDescriptionStack>
          </StyledTextStack>
          <StyledImageSectionStack>
            <CenterStack>
              {firstImgUrl && (
                <ZoomingImage imgUrl={firstImgUrl} fromRightSideOn />
              )}
              <StyledInfoStack>
                <CaseStudyDetailsStack
                  collaborationTimeframe={
                    latestCaseStudy?.collaborationTimeframe
                  }
                  services={latestCaseStudy?.case_study_services
                    .map((service) => service?.name)
                    .join(', ')}
                />
              </StyledInfoStack>
            </CenterStack>
          </StyledImageSectionStack>
        </StyledContentStack>

        {secondDesktopImgUrl && (
          <DesktopZoomingImage imgUrl={secondDesktopImgUrl} />
        )}

        {secondMobileImgUrl && (
          <MobileZoomingImage imgUrl={secondMobileImgUrl} />
        )}
      </StyledStack>
    </LatestCaseStudySection>
  );
};
